<template>
  <b-modal
    v-model="showModal"
    title="Filter Data"
    ok-title="Apply Filter"
    size="lg"
    @hide="$emit('close')"
    @ok="$emit('apply-filter')"
  >
    <template #modal-footer="{ ok, cancel }">
      <b-button variant="outline-secondary" @click="resetFilter">
        <i class="fas fa-undo mr-2"></i>
        Reset Filter
      </b-button>
      <b-button variant="secondary" @click="cancel()">Cancel</b-button>
      <b-button variant="primary" @click="ok()">Apply Filter</b-button>
    </template>
    <template v-if="filters">
      <b-form-group
        v-if="!$route.query?.maintenance_component_id"
        label="Category"
        label-for="fleet"
        label-cols="3"
      >
        <v-select
          v-model="filters.maintenance_component_id"
          id="fleet"
          multiple
          placeholder="Select Category"
          label="component_name"
          :options="categoryOptions"
          :reduce="(opt) => opt.id"
        ></v-select>
      </b-form-group>
      <b-form-group label="Used For" label-for="fleet" label-cols="3">
        <v-select
          v-model="filters.vehicleTypeIds"
          id="fleet"
          multiple
          placeholder="Select Vehicle Type"
          label="name"
          :options="typeFleet"
          :reduce="(opt) => opt.code"
        ></v-select>
      </b-form-group>
      <template v-if="tab != 'category'">
        <b-form-group label="Job Class" label-for="job-class" label-cols="3">
          <v-select
            v-model="filters.jobClassIds"
            id="job-class"
            multiple
            placeholder="Select Job Class"
            label="name"
            :options="jobClassOptions"
            :reduce="(opt) => opt.code"
          ></v-select>
        </b-form-group>
        <b-form-group label="Job Type" label-for="fleet" label-cols="3">
          <v-select
            v-model="filters.jobTypeIds"
            id="fleet"
            multiple
            placeholder="Select Job Type"
            label="name"
            :options="jobTypeOptions"
            :reduce="(opt) => opt.code"
          ></v-select>
        </b-form-group>
        <b-form-group
          label="Status"
          label-for="active"
          label-cols="3"
          class="mb-0"
        >
          <b-form-checkbox
            v-model="filters.active"
            name="check-button"
            switch
            inline
          >
            <template v-if="filters.active === false">No</template>
            <template v-else>Yes</template>
          </b-form-checkbox>
        </b-form-group>
      </template>
    </template>
  </b-modal>
</template>
<script>
import {
  fleetsActions,
  maintenanceActions,
  pmsActions,
} from '@/src/Utils/helper'

export default {
  name: 'FilterJobLibraries',
  props: {
    tab: {
      type: String,
      default: 'category',
    },
    showModalFilter: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      jobLibraries: [],
      categoryOptions: [],
      typeFleet: [],
      jobClassOptions: [],
      jobTypeOptions: [],
    }
  },
  computed: {
    showModal: {
      get() {
        return this.showModalFilter
      },
      set(value) {
        if (!value) this.$emit('close')
      },
    },
  },
  methods: {
    ...fleetsActions,
    ...maintenanceActions,
    ...pmsActions,
    resetFilter() {
      if (this.filters) {
        // Reset semua filter ke nilai default
        this.filters.maintenance_component_id = null
        this.filters.vehicleTypeIds = []
        this.filters.jobClassIds = []
        this.filters.jobTypeIds = []
        this.filters.active = true
        this.filters.search = ''

        // Emit event untuk apply filter setelah reset
        this.$emit('apply-filter')
      }
    },
    async getVehicleTypeData() {
      const res = await this.getFleetTypes()

      if (res.status === 'success' && Array.isArray(res.data)) {
        // langsung assign data yg aktif
        this.typeFleet = res.data
          .filter((item) => item.active)
          .map((element) => ({
            name: element.name,
            color:
              element.name === 'Tugboat'
                ? 'success'
                : element.name === 'Barge'
                ? 'warning'
                : 'primary',
            code: element.id,
          }))
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async fetchCategory() {
      const params = {
        limit: 9999,
        page: 1,
      }
      const res = await this.getEquipmentCategory(params)
      if (res.status === 'success') {
        const filteredData = res.data.data
        this.categoryOptions = filteredData
        console.log(res.data)
      } else {
        this.$swal(`Oops!`, res.data, 'error')
      }
    },

    async getJobClassList() {
      const params = {
        page: 1,
        perPage: 1000,
      }

      try {
        this.jobClassOptions = []
        const res = await this.getJobClass(params)
        res.data.data.forEach((el) => {
          this.jobClassOptions.push({
            name: `${el.jobClassCode} - ${el.jobClass}`,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },

    async getJobTypeList() {
      try {
        const params = {
          page: 1,
          perPage: 1000,
        }
        this.jobTypeOptions = []
        const res = await this.getJobType(params)
        res.data.data.forEach((el) => {
          this.jobTypeOptions.push({
            name: `${el.jobTypeCode} - ${el.jobTypeIndex}`,
            code: el.id,
          })
        })
      } catch (error) {
        console.log(error)
      }
    },
  },
  mounted() {
    this.getVehicleTypeData()
    if (!this.$route.query?.maintenance_component_id) {
      this.fetchCategory()
    }
    this.getJobClassList()
    this.getJobTypeList()
  },
}
</script>
